import React from 'react';

const ExternalLink = ({ to, children, ...props }) => {
  return (
    <a href={to} {...props}>
      {children}
    </a>
  );
};

export default ExternalLink;
